export interface IComponentPropertyUpdate {
  PublishedPropertyId: number,
  PropertyId: number,
  Value: string | null | undefined
}

export class UpdateComponentValuesCommand {
  public ContentComponentId: number = 0;
  public PageVersionSectionId: number = 0;
  public ColSpan: number = 0;
  public PosY: number = 0;
  public PosX: number = 0;
  public Width: number = 2;
  public Height: number = 5;
  public SiteId: string = "";
  public Values: Array<IComponentPropertyUpdate> = [];

  public AddProperyValue = (publishedpropertyid: number, propertyid: number, value: string | null | undefined) : void => {
    value = value === null || value === undefined ? "" : value;
    const val: IComponentPropertyUpdate = {
      PublishedPropertyId: publishedpropertyid,
      PropertyId: propertyid,
      Value: value
    }

    this.Values.push(val);
  }
}